module.exports = __webpack_public_path__ + "img/PG1-2-475x371.f1ffe570.png";